module.exports = __webpack_public_path__ + "static/service-shape4-488a471fccfc5a6f7b45a3a1d00f61eb.png";